import { render, staticRenderFns } from "./GoodsLimitSelect.vue?vue&type=template&id=167bbdb2&scoped=true"
import script from "./GoodsLimitSelect.vue?vue&type=script&lang=js"
export * from "./GoodsLimitSelect.vue?vue&type=script&lang=js"
import style0 from "./GoodsLimitSelect.vue?vue&type=style&index=0&id=167bbdb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167bbdb2",
  null
  
)

export default component.exports